import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { PlayCanvasApp } from '@app/PlayCanvasApp';
import { WorldIndexApp } from '@app/WorldIndexApp';
import { parseViewerRoute, shouldUseMobileLayout } from '@viewer/viewerRoute';
import './styles.css';

const rootElement = document.getElementById('root');

if (!rootElement) {
  throw new Error('Missing #root element');
}

const embeddedWorldId =
  document.querySelector<HTMLMetaElement>('meta[name="gointoit-world-id"]')?.content || null;
const autoMobile = shouldUseMobileLayout({
  userAgent: navigator.userAgent,
  maxTouchPoints: navigator.maxTouchPoints,
  coarsePointer: window.matchMedia('(pointer: coarse)').matches,
});
const route = parseViewerRoute(window.location.search, {
  pathname: window.location.pathname,
  embeddedWorldId,
  autoMobile,
});

function RootApp() {
  if (route.showIndex) return <WorldIndexApp />;
  return <PlayCanvasApp worldId={route.worldId ?? undefined} mobileLayout={route.mobileLayout} />;
}

createRoot(rootElement).render(
  <StrictMode>
    <RootApp />
  </StrictMode>,
);
